@if ($pinnedImage(); as image) {
    <cm-asset-grid-cell>
        <cm-asset-cell-chip cm-top-left>Pinned</cm-asset-cell-chip>
        <div cm-top-right class="cm-actions-slot">
            @if ($canDownload()) {
                <a [href]="image.downloadUrl" [download]="image.originalFileName">
                    <cm-asset-cell-chip interactive><i class="far fa-arrow-to-bottom"></i></cm-asset-cell-chip>
                </a>
            }
            @if ($canEdit()) {
                <cm-asset-cell-chip interactive [cdkMenuTriggerFor]="actionsMenu.menu()">
                    <i class="far fa-ellipsis-v"></i>
                </cm-asset-cell-chip>
                <cm-asset-actions-menu #actionsMenu [actions]="actions" (action)="onAction($event)" />
            }
        </div>
        <cm-data-object-thumbnail
            class="cm-thumbnail cm-clickable"
            [dataObjectId]="image.id"
            [layout]="ThumbnailLayout.Cover"
            [allowLabel]="false"
            (click)="preview.emit()"
        />
    </cm-asset-grid-cell>
}
